import { GRID_CHECKBOX_SELECTION_FIELD } from '@mui/x-data-grid';

// The selection checkbox column always stays where the table defines it
export const isColumnReorderLocked = (column) =>
	column.reorderable === false || column.field === GRID_CHECKBOX_SELECTION_FIELD;

const pinLockedColumns = (columns, ordered) => {
	const lockedFields = columns.filter(isColumnReorderLocked).map((column) => column.field);
	if (!lockedFields.length) return ordered;

	const next = ordered.filter((column) => !lockedFields.includes(column.field));

	columns.forEach((column, index) => {
		if (!lockedFields.includes(column.field)) return;
		next.splice(index, 0, column);
	});

	return next;
};

export const applyColumnOrder = (columns, order) => {
	if (!order.length) return columns;

	const columnByField = new Map(columns.map((column) => [column.field, column]));
	const seen = new Set();
	const next = [];

	for (const field of order) {
		const column = columnByField.get(field);
		if (!column) continue;
		next.push(column);
		seen.add(field);
	}

	for (const column of columns) {
		if (!seen.has(column.field)) next.push(column);
	}

	return pinLockedColumns(columns, next);
};
